import { Link } from "react-router-dom";
import { Flame, Target } from "lucide-react";
import { fmtNum } from "@/lib/studio";

const Bar = ({ value, goal, color, testid }) => (
  <div className="h-1.5 overflow-hidden rounded-full bg-[#1A202C]" data-testid={testid}>
    <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${Math.min(100, (Math.max(0, value) / goal) * 100)}%`, background: color }} />
  </div>
);

const StoryGoal = ({ s }) => (
  <li className="space-y-2 py-3" data-testid={`stats-goal-${s.id}`}>
    <div className="flex flex-wrap items-baseline justify-between gap-2">
      <Link to={`/u/${s.universe_id}/studio/${s.id}`} className="text-[#F3EBDD] hover:text-[#F59E0B]">{s.title}</Link>
      <span className="text-[11px] uppercase tracking-[0.14em] text-[#7A7468]">{s.universe_name}</span>
    </div>
    {s.goal_total ? <>
      <div className="flex justify-between text-xs text-[#A8A090]"><span>Book goal</span><span className="tabular-nums" data-testid={`stats-goal-${s.id}-total`}>{fmtNum(s.words)} / {fmtNum(s.goal_total)} · {Math.min(100, Math.round((s.words / s.goal_total) * 100))}%</span></div>
      <Bar value={s.words} goal={s.goal_total} color="#F59E0B" testid={`stats-goal-${s.id}-total-bar`} />
    </> : <div className="text-xs text-[#7A7468]">{fmtNum(s.words)} words · no book goal set</div>}
    {s.goal_daily > 0 && <>
      <div className="flex justify-between text-xs text-[#A8A090]"><span>Today</span><span className="tabular-nums" data-testid={`stats-goal-${s.id}-daily`}>{fmtNum(s.today_words)} / {fmtNum(s.goal_daily)}</span></div>
      <Bar value={s.today_words} goal={s.goal_daily} color="#10B981" testid={`stats-goal-${s.id}-daily-bar`} />
    </>}
  </li>
);

export const GoalsPanel = ({ stories, streak }) => (
  <section className="grid gap-6 rounded-md border border-[#2D3442] bg-[#0F131A] p-5 lg:grid-cols-[260px_1fr]" data-testid="stats-goals">
    <div className="space-y-5">
      <div className="lf-label">Streaks</div>
      <div className="flex items-end gap-3"><Flame className="h-8 w-8 text-[#F59E0B]" /><div><div className="font-display text-4xl text-[#F3EBDD]" data-testid="stats-streak-current">{streak.current}</div><div className="text-xs text-[#A8A090]">{streak.current === 1 ? "day" : "days"} in a row</div></div></div>
      <dl className="grid grid-cols-2 gap-3 text-xs">
        <div><dt className="text-[#7A7468]">Best streak</dt><dd className="mt-1 font-display text-xl text-[#F3EBDD]" data-testid="stats-streak-best">{streak.best} days</dd></div>
        <div><dt className="text-[#7A7468]">Writing days</dt><dd className="mt-1 font-display text-xl text-[#F3EBDD]" data-testid="stats-active-days">{streak.activeDays}</dd></div>
        <div className="col-span-2"><dt className="text-[#7A7468]">Today, all stories</dt><dd className="mt-1 font-display text-xl text-[#F3EBDD]" data-testid="stats-today-words">{fmtNum(streak.today)} words</dd></div>
      </dl>
      <p className="text-[11px] leading-relaxed text-[#7A7468]">A streak counts each day you add words to any story, over the last 400 days.</p>
    </div>
    <div>
      <div className="flex items-center gap-2"><Target className="h-4 w-4 text-[#F59E0B]" /><div className="lf-label">Story goals</div></div>
      {stories.length ? <ul className="mt-2 divide-y divide-[#2D3442]">{stories.map((s) => <StoryGoal key={s.id} s={s} />)}</ul>
        : <p className="mt-3 text-sm text-[#A8A090]">No stories yet. Start one in any universe's Writing Studio.</p>}
    </div>
  </section>
);
